import { Heart } from "lucide-react";

export const Wordmark = ({ size = "md", className = "" }) => {
  const scale = {
    sm: { top: "text-sm", sub: "text-[10px]", tag: "text-[9px]" },
    md: { top: "text-lg", sub: "text-[11px]", tag: "text-[10px]" },
    lg: { top: "text-3xl", sub: "text-sm", tag: "text-xs" },
  }[size];
  return (
    <div className={`leading-tight ${className}`} data-testid="brand-wordmark">
      <div className={`font-display font-semibold tracking-[0.12em] text-slate-900 ${scale.top}`}>
        THE WHITESTONE
      </div>
      <div className={`font-body font-medium tracking-[0.3em] text-slate-500 ${scale.sub}`}>
        HOTELS &amp; RESORTS
      </div>
      <div className={`mt-1 flex items-center gap-1 font-body font-semibold tracking-[0.25em] text-slate-700 ${scale.tag}`}>
        SWAGAT
        <Heart size={size === "lg" ? 14 : 11} className="fill-[#E63946] text-[#E63946]" />
        SE
      </div>
    </div>
  );
};
